export class DocumentItem {
    constructor(
        public idCliente:string,
        public Certificate:string,
        public Comments:string,
        public DocumentType: string,
        public FileName: string,
        public ImageData: string,
        public UserName:string,
    ){

    }
}
